<template>
    <div class="table-responsive"  v-loading="isBusy.table">
        <table class="table table-striped table-hover">
            <tbody>
                <tr>
                    <th>Name</th>
                    <th>Number</th>
                    <th>Destination numbers</th>
                    <th></th>
                    <th></th>
                </tr>
                <tr v-for="n in numbers" :key="n.id">
                    <td>{{ n.name }}</td>
                    <td>{{ n.number }}</td>
                    <td>{{ n.destination_number }}</td>
                    <td>
                        <a target="_blank" :href="getUpdateUrl(n)"> update</a>
                    </td>
                    <td>
                        <a href="javascript:void(0);" @click="requestTwilioDelete(n)" v-if="!(isBusy.dialog && (current.number && (current.number.number == n.number)))"> delete</a>
                        <i  v-if="(isBusy.dialog && (current.number && (current.number.number == n.number)))" class="fa fa-fw fa-spinner fa-spin"></i>
                    </td>
                </tr>
            </tbody>
        </table>

        <el-dialog title="Delete Twilio Number"
            :visible.sync="showForm" @close="closeDialog">

            <div>
                <p>The following jobs ({{current.jobs.length}}) are using the '{{ current.number && current.number.name}}' twilio number  ({{ current.number && current.number.number}})</p>
                <el-table
                    :data="current.jobs"
                    :height="tableHeight"
                    style="width: 100%">
                    <el-table-column label="Job Name" >
                        <template slot-scope="scope">
                            <!-- <el-link :href="getJobDetailUrl(scope.row)" >{{ scope.row.title }}</el-link> -->
                            <a target="_blank" :href="getJobDetailUrl(scope.row)">{{ scope.row.title }}</a>
                        </template>
                    </el-table-column>
                    <el-table-column label="Job ID" width="100">
                        <template slot-scope="scope">
                            <!-- <el-link :href="getJobDetailUrl(scope.row)" >{{ scope.row.id }}</el-link> -->
                            <a target="_blank"  :href="getJobDetailUrl(scope.row)">{{ scope.row.id }}</a>
                        </template>
                    </el-table-column>
                </el-table>

                <div class="row" v-loading="isBusy.dialog">
                    <div class="col-md-12" >
                        <p style="margin: 2rem 0;">What would you like to do?</p>
                    </div>
                    <div class="col-md-12" >
                        <el-radio-group v-model="current.radio">
                            <div style="margin: 1rem 0;">
                                <el-radio :label="'set-empty'">Set the phone value of the jobs to empty value</el-radio>
                            </div>
                            <div>
                                <el-radio :disabled="!canDoReplace" :label="'replace'">
                                    <span :style="{color: replaceOptionColor }">Use another twilio number of the employer instead:</span><br/>
                                    <el-select :disabled="!canDoReplace || current.radio === 'set-empty'"
                                               style="margin-left:2rem"
                                               size="large"
                                               v-model="current.select_value"
                                               placeholder="Please, select a number">
                                        <el-option
                                            v-for="(name,num) in current.numbers"
                                            :key="num"
                                            :label="name"
                                            :value="num">
                                        </el-option>
                                    </el-select>
                                </el-radio>
                            </div>
                        </el-radio-group>
                    </div>
                </div>
            </div>

            <span slot="footer" class="dialog-footer" >
                <el-button @click="deleteTwilio(current.select_value)" type="danger">Delete</el-button>
                <!-- <btn css-class="btn btn-danger" :click="deleteTwilio(current.select_value)">Delete</btn> -->
                <el-button @click="closeDialog" :disabled="isBusy.dialog">Close</el-button>
            </span>
        </el-dialog>

        <employer-notes-wrapper :employer-id="employer.id" />
    </div>
</template>

<script>
    export default {
        props: {
            numbers: { type: Array, required: true },
            employer: { type: Object, required: true },
        },
        data() {
            return {
                showForm : false,
                isBusy: {
                    dialog : true,
                    table : false
                },
                replaceOptionColor : 'auto',
                current : {
                    number : null,
                    jobs : [],
                    numbers : {},
                    select_value : null,
                    radio : 'set-empty',
                }
            };
        },
        computed: {
            canDoReplace() {
                return Object.keys(this.current.numbers).length > 0;
            },
            tableHeight() {
                return Math.min(Math.max(3,this.current.jobs.length), 8) * 50;
            }
        },
        methods: {
            requestTwilioDelete(number) {
                // if(this.current.number==number) return;
                
                this.isBusy.table = true;
                this.current.number=number;
                axios.get(url(`/admin/employer/${this.employer.id}/twilio/number/${number.id}/jobs`))
                    .then((response) => {
                        // console.log("related-jobs", response)
                        var jobs = response.data.jobs;
                        if(Array.isArray(jobs) && jobs.length>0)
                        {
                            this.showForm = true;
                            this.current.jobs=jobs;
                            this.current.numbers = {};
                            this.current.select_value = null;
                            this.isBusy.dialog = true;
                            axios
                                .get(url(`/employer/job/${this.employer.id}/twilio`))
                                .then((response)=>{
                                    this.current.numbers = response.data.items;
                                    if(this.current.numbers[number.number])
                                    {
                                        delete this.current.numbers[number.number];
                                    }
                                })
                                .catch((error)=>{
                                    this.$message.error(err.message);
                                })
                                .finally(()=>{
                                    this.isBusy.dialog = false;
                                    this.current.radio = this.canDoReplace ? 'replace' : 'set-empty';
                                    this.current.select_value = this.canDoReplace ? Object.keys(this.current.numbers).shift() : null;
                                    this.replaceOptionColor = this.canDoReplace ? 'auto' : 'red';
                                });
                            
                        }else{
                            //direct delete
                            this.deleteTwilio(null);
                        }
                    });
            
            },
            deleteTwilio(replaceNumber) {
                this.isBusy.dialog = true;
                const refreshUrl = url(`/admin/employer/${this.employer.id}/twilio`);
                if(!this.canDoReplace && replaceNumber) replaceNumber = null;
                if(this.canDoReplace && this.current.radio == 'set-empty') replaceNumber = null;
                return axios.get(`${refreshUrl}/number/${this.current.number.id}/delete/${replaceNumber}`)
                    .then((response) => {
                        let idx = this.numbers.indexOf(this.current.number);
                        if(idx>=0) this.numbers.splice(idx,1);
                    })
                    .catch((error)=>{
                        this.$message.error(err.message);
                    })
                    .finally(() => {
                        this.isBusy.table = false;
                        this.isBusy.dialog = false;
                        this.showForm = false;
                    });
            },
            closeDialog(){
                this.isBusy.table = false
                // this.isBusy.dialog = false;
                this.showForm = false;
            },
            getUpdateUrl(number)
            {
                return url('admin/employer/'+this.employer.id+'/twilio/number/'+number.id+'/update');
            },

            getJobDetailUrl(job)
            {
                return url(`admin/jobs/${job.id}`);
            },
        },
    };
</script>

